module.exports = __webpack_public_path__ + "static/media/cha.c869b8ef.wav";